'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DECIMAL_SEPARATOR = '.';
const THOUSAND_UNIT = 'k';
const formatNumber = (n) => {
    const numString = String(n);
    if (n < 1000) {
        return numString;
    }
    const decimalsMinusLast = numString.slice(0, numString.length - 3);
    const lastDecimal = numString.slice(numString.length - 3, numString.length - 2);
    return `${decimalsMinusLast}${DECIMAL_SEPARATOR}${lastDecimal}${THOUSAND_UNIT}`;
};

exports.formatNumber = formatNumber;
//# sourceMappingURL=format-number.js.map
